/* src/app/settings/email-integrations/email-integrations.component.scss */
/*# sourceMappingURL=email-integrations.component-LQ6A5OG5.css.map */
